$(document).ready(function(){
  var url = window.location.href,
    parts = url.split("/"),
    last_part = parts[parts.length-1];

  if(last_part == ''){
      last_part = parts[parts.length-2];
  }

  console.log(last_part);

  if(last_part == 'leandra-buchi'){
    window.location.replace("https://projektwoche.ch/pages/team");
  }
  
  if(last_part.indexOf('?') != -1){
    var url = window.location.href,
    parts = url.split("?"),
    plast_part = parts[parts.length-2],
    fparts = plast_part.split("/"),
    last_part = fparts[fparts.length-1];

    if(last_part == ''){
        last_part = fparts[fparts.length-2];
    }
  }
  if($('#team-modal-popup').length > 0){
    last_part = $('#cus-pro-id').val();
  }
  if($('#team-modal-popup').length <= 0){
    var personName = $('.contact_person .person.'+last_part).children('h3').text();
    $('title').text(personName + ' - Projektwoche Züri Oberland');
  }
  
  $('.contact_person .person').addClass('hidden');
  $('.contact_person .person.'+last_part).removeClass('hidden');
  $('.contact_person .person').children('input').attr('disabled',true);
  $('.contact_person .person.'+last_part).children('input').attr('disabled',false);

  jQuery("form#person-ContactForm").validate();

  $(document).on('click','form#person-ContactForm .contact__button button', function(){
    if(jQuery('form#person-ContactForm').valid()){
      var $this = $(this);
      var $form = $("form#person-ContactForm");
      var formData = getFormData($form);
      // console.log(JSON.stringify(formData));

       $.ajax({
        url: "https://app.aico.swiss/19853/api/v1/ecommerce-orders/contact-mail",
        // url: "https://domi-ecommerce.free.beeceptor.com/",
        type: "POST",
        data: JSON.stringify(formData),
        headers:{"Authorization": "Bearer 0qqTsILksEd15jj82FAz1x5rxGZdal5KIs97v6zn", "Accept":'application/vnd.api+json', 'Content-type':'application/vnd.api+json'},
        beforeSend: function(){
          $this.attr('disabled',true);
        },
        success: function (data) {
          $('form#person-ContactForm .field .contact-part').children('input').val('');
          $('form#person-ContactForm .field .contact-part').children('textarea').val('');
          $('form#person-ContactForm .form__message_seccess').removeClass('hidden');

          setTimeout(function(){
            $('form#person-ContactForm .form__message_seccess').addClass('hidden');
          },5000)
        },
        complete:function(){
          $this.attr('disabled',false);
        },
         error:function(jqXHR, textStatus, errorThrown ){
          console.log(textStatus);
           $('form#person-ContactForm .form__message_error').removeClass('hidden');

          setTimeout(function(){
            $('form#person-ContactForm .form__message_error').addClass('hidden');
          },5000)
        }
         
      });
    }
  });
  
});

function getFormData($form){
    var unindexed_array = $form.serializeArray();
    var indexed_array = {};

    $.map(unindexed_array, function(n, i){
        indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
}